import { useState, useEffect } from "react";
import { TIER_ORDER, TIER_META } from "../../lib/tiers";

const GLOBAL = [
  ["owner_pct", "Your cut (%)"], ["charity_pct", "Trip-cycle share to scholarships (%)"],
  ["autopay_discount_pct", "Autopay discount (%)"], ["offer_days", "Days to decide on offer"],
  ["duo_price_multiplier", "2-person price ×"], ["duo_trip_multiplier", "2-person trip ×"],
  ["family_price_multiplier", "Family of 4 price ×"], ["family_trip_multiplier", "Family of 4 trip ×"],
  ["extra_person_price_multiplier", "Extra person price ×"], ["extra_person_trip_multiplier", "Extra person trip ×"],
  ["buy_now_fee_pct", "Buy-it-now fee (%)"],
  ["broker_booking_fee_pct", "Partner booking fee (%)"], ["broker_commission_pct", "Partner commission (%)"], ["broker_owner_pct", "Partner owner share (%)"], ["broker_charity_pct", "Scholarship % of partner commission"], ["coo_rate_limit_pct", "COO pay-rate change limit (±%)"], ["broker_max_active_per_line", "Max packages per partner per line"],
  ["premium_price_multiplier", "Premium price ×"], ["premium_trip_multiplier", "Premium trip ×"],
  ["founder_limit", "Founding spots"], ["founder_discount_pct", "Founding discount (%)"], ["founder_perk_count", "First-member perk count"],
];
const INTS = ["offer_days", "founder_limit", "founder_perk_count", "broker_max_active_per_line"];

const Num = ({ tid, label, value, onChange, step = "0.01" }) => (
  <label className="block"><span className="text-[11px] text-slate-400">{label}</span>
    <input data-testid={tid} type="number" step={step} value={value} onChange={(e) => onChange(e.target.value)} className="lux-input mt-1 font-mono-lux !py-2" /></label>
);

export const SettingsCard = ({ stats, onSave }) => {
  const [f, setF] = useState(null);
  useEffect(() => {
    if (!stats) return;
    setF({
      ...Object.fromEntries(GLOBAL.map(([k]) => [k, stats[k]])),
      founder_perk_text: stats.founder_perk_text,
      blocked_states: (stats.blocked_states || []).join(", "),
      terms_version: stats.terms_version,
      tiers: Object.fromEntries(TIER_ORDER.map((t) => [t, { monthly_fee: stats.tiers[t].base_fee, vacation_cost: stats.tiers[t].base_vacation_cost }])),
    });
  }, [stats]);
  if (!f) return null;
  const setT = (t, k) => (v) => setF({ ...f, tiers: { ...f.tiers, [t]: { ...f.tiers[t], [k]: v } } });
  const submit = (e) => {
    e.preventDefault();
    onSave({
      ...Object.fromEntries(GLOBAL.map(([k]) => [k, Number(f[k])])),
      founder_perk_text: f.founder_perk_text,
      blocked_states: f.blocked_states.split(",").map((x) => x.trim()).filter(Boolean),
      terms_version: f.terms_version,
      tiers: Object.fromEntries(TIER_ORDER.map((t) => [t, { monthly_fee: Number(f.tiers[t].monthly_fee), vacation_cost: Number(f.tiers[t].vacation_cost) }])),
    });
  };
  return (
    <form onSubmit={submit} className="lux-card p-6 space-y-5" data-testid="settings-card">
      <p className="eyebrow">Club economics</p>
      <div className="grid grid-cols-2 gap-3">
        {GLOBAL.map(([k, label]) => <Num key={k} tid={`settings-${k}`} label={label} value={f[k]} step={INTS.includes(k) ? "1" : "0.01"} onChange={(v) => setF({ ...f, [k]: v })} />)}
      </div>
      <label className="block"><span className="text-[11px] text-slate-400">First-member perk (what the very first founders get)</span>
        <input data-testid="settings-founder_perk_text" value={f.founder_perk_text} onChange={(e) => setF({ ...f, founder_perk_text: e.target.value })} className="lux-input mt-1 !py-2" /></label>
      <label className="block"><span className="text-[11px] text-slate-400">Blocked states (2-letter codes, comma separated)</span>
        <input data-testid="settings-blocked_states" value={f.blocked_states} onChange={(e) => setF({ ...f, blocked_states: e.target.value })} className="lux-input mt-1 !py-2" /></label>
      <label className="block"><span className="text-[11px] text-slate-400">Terms version (change it to make everyone re-accept)</span>
        <input data-testid="settings-terms_version" value={f.terms_version} onChange={(e) => setF({ ...f, terms_version: e.target.value })} className="lux-input mt-1 !py-2" /></label>
      <p className="eyebrow !text-slate-500">Per line · base 1-person price & trip</p>
      {TIER_ORDER.map((t) => (
        <div key={t} className="grid grid-cols-2 gap-3">
          <Num tid={`settings-${t}-fee`} label={`${TIER_META[t].short} $/mo`} value={f.tiers[t].monthly_fee} onChange={setT(t, "monthly_fee")} />
          <Num tid={`settings-${t}-cost`} label="Trip $" value={f.tiers[t].vacation_cost} onChange={setT(t, "vacation_cost")} />
        </div>
      ))}
      <button data-testid="settings-save-btn" className="btn-ghost w-full py-2.5 text-sm">Save settings</button>
    </form>
  );
};
